import axiosClient from 'utils/axiosClient';
import api from 'api';

const getEbooksAccessLogs = async (data: any) => {
	const response = await axiosClient.get(api.LIBRARY.EBOOKS.EBOOKS_ACCESS_LOGS, {params: data});
	return response.data;
};

const getEbooksRead = async (id: any, data?: any) => {
	const response = await axiosClient.get(api.LIBRARY.EBOOKS.EBOOK_READ + `${id}/read`, {params: data});
	return response.data;
};

const service = {
	getEbooksAccessLogs,
	getEbooksRead
};

export default service;
